import { shapeClass } from "../../lib/shape.js";
import { TONES } from "../../lib/tones.js";

/* Chip's class tables, split out of Chip.tsx (as Button's are in
   button-variants.ts). Chip declares no pressed, tone or corner paint of its
   own: the Button root and body take theirs from Button, the frame's corner
   is the `pill` word from lib/shape.ts, and its ai paint is TONES.ai.soft.
   Literal class strings so Tailwind sees them. */

export type ChipTone = "neutral" | "ai";
export type ChipSize = "md" | "lg";

/* FilterChip's frame, moved from FilterBar.tsx: today's classes at md. */
export const FRAME = `inline-flex items-center gap-1.5 ${shapeClass("pill")} border text-xs`;
export const FRAME_SIZE: Record<ChipSize, string> = {
  md: "ps-2.5 pe-1.5 py-0.5",
  lg: "h-7 ps-3 pe-2",
};
/* With a body Button the body pads the start, so the frame does not. */
export const FRAME_SIZE_WITH_BODY: Record<ChipSize, string> = {
  md: "gap-1 pe-1.5",
  lg: "h-7 gap-1 pe-2",
};
export const FRAME_PAINT: Record<ChipTone, string> = {
  neutral: "border-pb-control-border bg-pb-card text-pb-text",
  ai: TONES.ai.soft,
};

/* Button sizes: the Button root is xs (24px) at md and sm (28px) at lg.
   The fit classes give it the frame's start padding and text size, so a
   label reads the same in every form. */
export const BUTTON_SIZE = { md: "xs", lg: "sm" } as const;
export const BUTTON_FIT: Record<ChipSize, string> = {
  md: "px-2.5 text-xs",
  lg: "px-3",
};
/* The ghost body fills the frame's inner height (20px / 26px) and takes
   the frame's ink at rest and on hover, so only Button's hover wash, press
   and focus ring show. Disabled, the frame already dims the whole chip, so
   the body does not dim a second time. */
export const BODY_FIT: Record<ChipSize, string> = {
  md: "h-5 gap-1.5 ps-2.5 pe-1 text-xs",
  lg: "h-6.5 gap-1.5 ps-3 pe-1",
};
export const BODY_INK = "text-inherit hover:text-inherit disabled:opacity-100";
export const ICON_BOX: Record<ChipSize, string> = {
  md: "inline-flex shrink-0 [&>svg]:size-3",
  lg: "inline-flex shrink-0 [&>svg]:size-3.5",
};
